export default "__VITE_ASSET__DGqjsqUY__"